import { Button } from "@components/ui/button"
import { Link } from "@components/ui/link"
import { ModalOrSidebar } from "@components/ui/modal-sidebar"
import { Text } from "@components/ui/typograhpy/Text"
import React from "react"

type Props = {
  open: boolean
  setOpen: (open: boolean) => void
  onConfirm: VoidFunction
  loading: boolean
}
const UpgradeSubscriptionConfirmModal = ({
  open,
  setOpen,
  onConfirm,
  loading,
}: Props) => {
  return (
    <ModalOrSidebar open={open} onOpenChange={setOpen} title="Upgrade plan">
      <Text variant="regular" className="mb-6">
        You are using the basic plan, if you upgrade to Business plan, the
        difference between Basic and Business plan will be charge immediately
        through your card, based on you last invoice.
      </Text>
      <Text variant="regular" className="mb-6">
        Are you sure you want to proceed?
      </Text>
      <div className="flex items-end justify-between">
        <Link as="button" onClick={() => setOpen(false)}>
          Cancel
        </Link>
        <Button
          variant="primary"
          status={loading ? "loading" : "idle"}
          type="button"
          onClick={onConfirm}
        >
          Yes, upgrade my plan
        </Button>
      </div>
    </ModalOrSidebar>
  )
}

export default UpgradeSubscriptionConfirmModal
